import classes from "./MealsSummary.module.css";

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Enjoy our specialty edge-to edge pizza!</h2>
      <p>
        Bring something new to the table. Traditional brick Ovens x Pizza Made
        in Italy.
      </p>
      <p>Shipping WorldWide. Wood fire ovens. Professional ovens.</p>
    </section>
  );
};

export default MealsSummary;
